import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetPaymentStatusAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const paymentStatus = createAsyncThunk('get/paymentStatus', GetPaymentStatusAPI);

export const CheckPaymentStatusSlice = createSlice({
	name: 'paymentStatus',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[paymentStatus.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[paymentStatus.rejected.toString()]: setAPIError,
		[paymentStatus.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[CheckPaymentStatusSlice.name]: ReturnType<typeof CheckPaymentStatusSlice.reducer>;
}

export const paymentStatusSelector = (state: IStates): any => {
	return state[CheckPaymentStatusSlice.name] || {};
};

export const usePaymentStatus = (): any => useSelector(paymentStatusSelector);

export const checkPaymentStatus =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(paymentStatus(params));
		return;
	};

export const resetPaymentStatus =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(CheckPaymentStatusSlice.actions.RESET());
		return;
	};
